import { RouteWaypointModel } from '@fe/core';
import { TerrainPoint } from '../profile/types';

export const enum MessageType {
    initialized = 'initialized',
    loadTerrain = 'loadTerrain',
    cancelLoadTerrain = 'cancelLoadTerrain'
}

export type RequestResponseMessageMap = {
    [MessageType.initialized]: [void, void];
    [MessageType.loadTerrain]: [{ id: number; waypoints: RouteWaypointModel[] }, TerrainPoint[]];
    [MessageType.cancelLoadTerrain]: [void, void];
};
